export default __webpack_public_path__ + "static/media/Prompt-Italic.3cd63845.ttf";